import React, { useMemo } from 'react';

import { useStoredDataChanged } from './useStoredDataChanged';
import Loader from './Loader';

const LoadUserAvailability = ({ eventId, children }) => {
    const memoizedPromise = useMemo(() => app.api.meetings.checkAvailability(eventId), [eventId]);

    useStoredDataChanged();
    return (
        <Loader skipSpinner={(state) => state.events[eventId]?.availability.loaded} promises={[memoizedPromise]}>
            {children}
        </Loader>
    );
};

export default LoadUserAvailability;
